/* eslint-disable no-unused-vars */
import { useState } from 'react';
import classNames from 'classnames';
import Swal from 'sweetalert2';
import loadingGif from '../../assets/Other/loading.gif';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import { toast } from 'react-toastify';
import PasswordResetWindow from '../PasswordReset/PasswordResetWindow';
import AddingUserModal from './AddingUserModal';
import { currentUser } from '../../utils/Auth/auth';
import SetPasswordAndCreateUser from '../PasswordReset/SetPasswordAndCreateUser';

const defaultUser = {
  id: 0,
  branchId: Number.parseInt(currentUser?.baseBranch) || 1,
  role: 'AGENT',
  country: currentUser?.baseBranch === '1' ? 'CAN' : 'USA',
  subType: 'REGULAR',
  rateGroup: 'OOREG',
  status: 'Active',
};

const defaultUser2 = {
  id: 0,
  branchId: Number.parseInt(currentUser?.baseBranch) || 1,
  customerCd: null,
  email: null,
  passwordHash: null,
  role: 'AGENT',
  birthday: null,
  firstName: null,
  lastName: null,
  country: null,
  state: null,
  zip: null,
  city: null,
  apartment: null,
  house: null,
  address: null,
  phone: null,
  registrationDate: null,
  subType: 'REGULAR',
  accessCode: null,
  rateGroup: 'OOREG',
  rateGroupMT: null,
  status: 'Active',
  statusDate: null,
  activationDate: null,
  foxId: null,
  billingLastName: null,
  billingFirstName: null,
  billingCountry: null,
  billingZip: null,
  billingState: null,
  billingRegion: null,
  billingCity: null,
  billingApartment: null,
  billingHouse: null,
  billingAddress: null,
  lastIp: null,
  lastAccountDate: null,
  sessionId: null,
  sessionExpire: null,
  warehouseId: null,
  section: null,
  language: null,
  notice: null,
  editDate: null,
  source: null,
  bpStatus: null,
  bpStatusDate: null,
  bpStatusUser: null,
  optIn: null,
};

const AddingUserFrame = ({ swalModal }) => {
  const [newData, setNewData] = useState(defaultUser);
  const [updateLoading, setUpdateLoading] = useState();

  const setPassword = async () => {
    if (!(newData?.email?.length <= 0 || !newData?.email)) {
      swalModal.fire({
        title: 'Set password',
        html: <SetPasswordAndCreateUser swalModal={swalModal} data={newData} />,
        showCancelButton: false,
        showConfirmButton: false,
        cancelButtonText: 'Close',
        customClass: {
          confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
          cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
          popup: 'w-auto max-w-[65%] text-sm',
        },
      });
    }
  };
  return (
    <div>
      <div>
        <AddingUserModal data={newData} setData={setNewData} />
      </div>
      <div className="p-4">
        <div
          className={classNames(
            'text-left text-sm my-1',
            newData?.email?.length <= 0 ||
              !newData?.email ||
              newData?.customerCd?.length <= 0 ||
              !newData?.customerCd
              ? 'text-yellow-600'
              : 'opacity-0',
          )}
        >
          Mandatory field missed
        </div>
        {updateLoading ? (
          <img
            className="w-5 h-5 mx-auto float-left my-2 ml-3"
            src={loadingGif}
          />
        ) : (
          <div
            onClick={setPassword}
            className={classNames(
              'float-left bg-blue-900 text-white inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer hover:bg-blue-800 hover:transition-all hover:duration-300',
              (newData?.email?.length <= 0 ||
                !newData?.email ||
                newData?.customerCd?.length <= 0 ||
                !newData?.customerCd) &&
                '!bg-gray-400 !cursor-auto',
            )}
          >
            Create
          </div>
        )}

        <div
          onClick={() => Swal.close()}
          className={classNames(
            'float-right bg-gray-300 text-gray-700 inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer hover:bg-gray-400 hover:transition-all hover:duration-300',
          )}
        >
          Close
        </div>
      </div>
    </div>
  );
};

export default AddingUserFrame;
